// Charger Types translations for React Admin resource
export const chargerTypesResource = {
  name: 'Charger Types',
  fields: {
    id: 'ID',
    name: 'Name',
    displayName: 'Display Name',
    minPowerKw: 'Min Power (kW)',
    maxPowerKw: 'Max Power (kW)',
    powerRange: 'Power Range',
    colorCode: 'Color Code',
    icon: 'Icon',
    displayOrder: 'Display Order',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
  },
};

// Custom charger types translations for components
export const chargerTypes = {
  sections: {
    basic: 'Basic Information',
    power: 'Power Configuration',
    display: 'Display Settings',
    metadata: 'Metadata',
  },
  list: {
    title: 'Charger Types',
    filters: {
      search: 'Search by name',
    },
    empty: {
      title: 'No charger types found',
      subtitle: 'Create your first charger type to categorize charging stations.',
    },
  },
  create: {
    title: 'Create Charger Type',
    subtitle: 'Define a new charger type configuration',
    backToList: 'Back to List',
  },
  edit: {
    title: 'Edit Charger Type',
    subtitle: 'Modify charger type configuration',
    backToList: 'Back to List',
  },
  delete: {
    confirmTitle: 'Delete Charger Type',
    confirmContent: 'Are you sure you want to delete this charger type? This action cannot be undone.',
  },
  validation: {
    idTooLong: 'ID must be less than 50 characters',
    idFormat: 'ID must be lowercase alphanumeric with hyphens only',
    nameTooLong: 'Name must be less than 100 characters',
    displayNameTooLong: 'Display name must be less than 100 characters',
    powerNegative: 'Power cannot be negative',
    powerTooHigh: 'Power value is too high',
    colorFormat: 'Color must be in hex format (e.g., #FF0000)',
    iconTooLong: 'Icon name must be less than 100 characters',
    orderNegative: 'Display order cannot be negative',
    orderTooHigh: 'Display order is too high',
  },
  helpers: {
    id: 'Unique identifier (lowercase, hyphens allowed)',
    idFixed: 'ID cannot be changed after creation',
    name: 'Internal name for this charger type',
    displayName: 'User-friendly name shown in the app',
    minPower: 'Minimum power in kilowatts',
    maxPower: 'Maximum power in kilowatts (leave empty for no limit)',
    colorCode: 'Hex color code for visual representation',
    icon: 'Icon identifier for mobile app',
    displayOrder: 'Sort order for display (lower numbers appear first)',
  },
  info: {
    idNote: 'The ID will be used as a unique identifier and cannot be changed after creation',
    idCannotChange: 'The ID cannot be changed after creation to maintain data integrity',
    powerNote: 'Power range helps categorize connectors automatically',
    displayNote: 'Display settings control how this type appears in the mobile app',
  },
  notifications: {
    created: 'Charger type created successfully',
    updated: 'Charger type updated successfully',
    deleted: 'Charger type deleted successfully',
    error: {
      create: 'Failed to create charger type',
      update: 'Failed to update charger type',
      delete: 'Failed to delete charger type',
    },
  },
  actions: {
    create: 'Create Charger Type',
    save: 'Save Charger Type',
    delete: 'Delete Charger Type',
    cancel: 'Cancel',
  },
};